<lib-dynamic-listing
  [module]="'asset_maintenance_request'"
  [filters]="filterConfigs"
  [columns]="columnConfigs"
  [data]="tableData"
  [actions]="actionConfigs"
  [isLoading]="isLoading"
  [pageIndex]="pageIndex"
  [rowsPerPage]="rowsPerPage"
  [totalCount]="totalCount"
  [totalPages]="totalPages"
  [exportFilename]="exportFilename"
  [columnPreferenceId]="columnPreferenceId"
  (filterEvent)="onFilterEvent($event)"
  (actionClicked)="onActionClicked($event)"
  (pageChanged)="onPageChanged($event)"
  (exportCsv)="exportCsv()"
  (exportXlsx)="exportXlsx()"
  (exportPdf)="exportPdf()"
  (columnPreferenceSaved)="onColumnPreferenceSaved($event)">
</lib-dynamic-listing>
